import { Flex, Text, FormRadioSelection } from '@shared/components';
import { useMemo } from 'react';

export interface ContentTypeSectionProps {
  contentType?: 'LOS' | 'TOPIC';
  isEditModal?: boolean;
}

export default function ContentTypeSection(props: Readonly<ContentTypeSectionProps>) {
  const { contentType, isEditModal } = props;

  const contentTypeOptions = useMemo(
    () => [
      { label: 'Topic/Subtopic', value: 'TOPIC', disabled: contentType === 'LOS' && isEditModal },
      { label: 'LOS', value: 'LOS', disabled: contentType === 'TOPIC' && isEditModal },
    ],
    [contentType, isEditModal],
  );
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        p: theme.spacing(4),
        gap: theme.spacing(1),
      })}
    >
      <Text variant='body2Semibold'>Content Type</Text>
      <FormRadioSelection name='contentType' options={contentTypeOptions} row />
    </Flex>
  );
}
